module.exports = __webpack_public_path__ + "img/advert-banner3.590affc0.jpg";